import { render, staticRenderFns } from "./ViewCaixaCto.vue?vue&type=template&id=2e60525d&scoped=true&"
import script from "./ViewCaixaCto.vue?vue&type=script&lang=js&"
export * from "./ViewCaixaCto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e60525d",
  null
  
)

export default component.exports